import { render } from "./UiSelect.vue?vue&type=template&id=82abb030"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__